// @flow
import xws from 'api/xws/';
import qs from 'query-string';
import type { AxiosPromise } from 'axios';

// Constants
import { getService } from 'constants/ajax';

export type DeleteVehicleResponse = {|
  key?: string,
  message?: string,
  statusCode?: number,
  success: boolean
|};

type RequestData = {|
  authId: string,
  webkey: string,
  vehicleId: number
|};

export function deleteVehicleWs({
  authId,
  webkey,
  vehicleId
}: RequestData): AxiosPromise<RequestData, DeleteVehicleResponse> {
  const deleteVehicleService = getService('deleteVehicle');
  deleteVehicleService.setPathVars({ vehicleId });
  return xws(deleteVehicleService).post(
    deleteVehicleService.getPath(),
    qs.stringify({ authId, webkey })
  );
}



// WEBPACK FOOTER //
// ./src/api/xws/vehicle/deleteVehicleWs.js